import "./App.css";
import React from "react";

import WeatherApp from "./components/WeatherApp";

function App() {
  return (
    <div>
      <WeatherApp />
    </div>
  );
}

export default App;
